import { useEffect, useState } from 'react';
import styles from './help.module.scss';
import homeServices from '../../../store/services/homeServices';
import LoaderComponent from '../../components/nds/loader/loader';
import { toast, ToastContainer } from 'react-toastify';
import NexusToast from '../../components/common/toast/NexusToast';

const Help = () => {
    const [isShowLoader, setIsShowLoader] = useState<boolean>(false);
    useEffect(() => {}, []);

    const downloadUserManual = () => {
        setIsShowLoader(true);
        homeServices
            .downloadHelpManual()
            .then((response) => {
                let fileName = 'User_Manual.pdf'; // Default file name
                // Create a URL for the file
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); // Use the extracted file name
                document.body.appendChild(link);
                link.click();
                link.remove();
                setIsShowLoader(false);
                toast(<NexusToast type='success' message='File Downloaded Successfully!' />);
            })
            .catch(() => {
                setIsShowLoader(false);
                toast(<NexusToast type='error' message='Error while Downloading!' />);
            });
    };

    return (
        <>
            <div className={styles['help-container']} data-testid='help-container'>
                <div className={styles['help-col']}>
                    <div className={styles['risk-header']}>
                        <div className={`${styles['page-header-font']} nexus-h3 nexus-pb-2`}>Help</div>
                    </div>

                    <div>
                        <p>
                            <b>General and Functionality Queries:</b>
                        </p>
                        <p>
                            Tom Hilverkus -{' '}
                            <a className={styles['download-link']} href='mailto:thilverkus@uk.ey.com'>
                                thilverkus@uk.ey.com
                            </a>
                        </p>

                        <br />
                        <p>
                            <b>Tax Technical and Content Queries:</b>
                        </p>
                        <p>
                            Menuka Thajali -{' '}
                            <a className={styles['download-link']} href='mailto:menuka.thajali@uk.ey.com'>
                                menuka.thajali@uk.ey.com
                            </a>
                        </p>
                        <p>
                            Katie Hawcutt -{' '}
                            <a className={styles['download-link']} href='mailto:katie.hawcutt@uk.ey.com'>
                                katie.hawcutt@uk.ey.com
                            </a>
                        </p>
                        <br />
                        <p>
                            <b>My EY Access and IT Queries (e.g., adding users):</b>
                        </p>
                        <p>
                            Anupama Singh -{' '}
                            <a className={styles['download-link']} href='mailto:anupama.singh@gds.ey.com'>
                                anupama.singh@gds.ey.com
                            </a>
                        </p>

                        <p>
                            <a onClick={downloadUserManual} target='_blank' className={styles['download-link']}>
                                Click here
                            </a>{' '}
                            to download the User Manual
                        </p>
                    </div>
                </div>
            </div>
            <ToastContainer
                position='top-center'
                autoClose={3000}
                hideProgressBar
                closeOnClick
                pauseOnHover
                draggable
                toastClassName='bg-transparent shadow-none'
            />
            <LoaderComponent show={isShowLoader} fullscreen={true} />
        </>
    );
};

export default Help;
